module.exports = __webpack_public_path__ + "static/media/scenario6_preview.231a7b70.jpg";